import React from 'react'
import styled from 'styled-components'
import { pxToRem } from '../utils'
import { CloseIcon, EditIcon, MatrixIcon, PdfIcon, QrCodeIcon } from './icons'
import Can from './Can'

const Wrapper = styled.div`
  background: #fff;
  font-family: 'Open Sans', sans-serif;
  border-radius: ${pxToRem('7px')};
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #dadfe2;
  padding: ${pxToRem(13)} ${pxToRem(20)};
  border-radius: ${pxToRem('7px')} ${pxToRem('7px')} 0 0;
`

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: #5b666d;
  font-size: ${pxToRem(15)};
  text-transform: uppercase;
  font-weight: bold;
`

const Action = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`

const Content = styled.div`
  padding: ${pxToRem('24px')};
`

class Card extends React.PureComponent {
  render() {
    const {
      editButtonAction,
      closeButtonAction,
      exportButtonAction,
      qrCodePrintButtonAction,
      matrixButtonAction,
      children,
      title,
      height,
      editPermission = '',
      closePermission = '',
      matrixPermission = '',
      ...rest
    } = this.props

    return (
      <Wrapper {...rest}>
        <Header>
          <Title style={{ overflow: 'hidden'}}>{title}</Title>
          <Action>
            {editButtonAction && (
              <Can functionality={editPermission}>
                <Button onClick={editButtonAction} style={{ marginRight: 8 }}>
                  <EditIcon color="#5B666D" />
                </Button>
              </Can>
            )}
            {matrixButtonAction && (
              <Can functionality={matrixPermission}>
                <Button onClick={matrixButtonAction} style={{ marginRight: 8 }}>
                  <MatrixIcon color="#5B666D" width="18px" height="18px" />
                </Button>
              </Can>
            )}
            {exportButtonAction && (
              <Button onClick={exportButtonAction} style={{ marginRight: 8 }}>
                <PdfIcon color="#5B666D" />
              </Button>
            )}
            {qrCodePrintButtonAction && (
              <Button onClick={qrCodePrintButtonAction}>
                <QrCodeIcon color="#5B666D" width="18px" height="18px" />
              </Button>
            )}
            {closeButtonAction && (
              <Can functionality={closePermission}>
                <Button onClick={closeButtonAction} style={{ marginLeft: 4 }}>
                  <CloseIcon color="#e57373" />
                </Button>
              </Can>
            )}
          </Action>
        </Header>
        <Content>{children}</Content>
      </Wrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js